import { FirestoreDataConverter } from "firebase/firestore";

export interface InterestForm {
    /**
     * The unique ID.
     */
    // readonly id: string;
    /**
     * User ID if authenticated; session ID if not authenticated.
     * This is populated after the user completes the sign up process.
     */
    uid: string;

    isAnonymous: boolean;

    nctID: string;

    isProxy?: boolean;

    searchLogId?: string;

    /**
     * This is a copy of the search log because it's critical to have this information to search for similar studies.
     */
    searchLog?: string;

    /**
     * Optional: List of conditions related to this study.
     */
    conditions?: string[];

    createdAt?: Date;

    sessionId?: string;
}

class InterestFormResult implements InterestForm {
    /**
     * User ID if authenticated; session ID if not authenticated.
     * This is populated after the user completes the sign up process.
     */
    readonly uid: string;

    readonly isAnonymous: boolean;

    readonly nctID: string;

    readonly isProxy?: boolean;

    readonly searchLogId?: string;

    readonly searchLog?: string;

    readonly createdAt: Date;

    readonly sessionId?: string;

    /**
     * Optional: List of conditions related to this study.
     */
    readonly conditions?: string[];

    constructor(data: InterestForm) {
        this.uid = data.uid;
        this.isAnonymous = data.isAnonymous;
        this.nctID = data.nctID;
        this.isProxy = data.isProxy;
        this.searchLogId = data.searchLogId;
        this.conditions = data.conditions;
        this.createdAt = data.createdAt || new Date();
        if (data.searchLog) this.searchLog = data.searchLog;
        this.sessionId = data.sessionId;
    }
}

function cleanUndefinedValues(obj: object) {
    return Object.fromEntries(
        Object.entries(obj).filter(([, value]) => value !== undefined)
    );
}

const interestFormConverter: FirestoreDataConverter<InterestFormResult> = {
    toFirestore(data: InterestFormResult) {
        const firestoreObject: InterestForm = {
            uid: data.uid,
            isAnonymous: data.isAnonymous,
            nctID: data.nctID,
            isProxy: data.isProxy,
            searchLogId: data.searchLogId,
            searchLog: data.searchLog,
            conditions: data.conditions,
            createdAt: data.createdAt,
            sessionId: data.sessionId,
        };

        return cleanUndefinedValues(firestoreObject);
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return new InterestFormResult({
            uid: data.uid,
            isAnonymous: data.isAnonymous,
            nctID: data.nctID,
            isProxy: data.isProxy,
            searchLogId: data.searchLogId,
            searchLog: data.searchLog,
            conditions: data.conditions,
            createdAt: data.createdAt,
            sessionId: data.sessionId,
        });
    },
};

export { InterestFormResult };
export default interestFormConverter;
